import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import profile from "../../images/Icons/man.png";
import camera from "../../images/Icons/camera.png";
import success from "../../images/Icons/success.png";
import useLogout from "../Auth/useLogout";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

export default function TransporterProfile() {
  const logout = useLogout();
  const [loading, isLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "", 
    email: "",
    phone: "",
    company_name: "",
    gst_number: "",
    address: "", 
    alternate_phone: "",
    aadhar_number: "",
  });
  const [responseError, setResponseError] = useState({
    nameError: "",
    companyError: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/transporter/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        email: response.data.data.email ?? "",
        phone: response.data.data.phone ?? "",
        company_name: response.data.data.transporter_detail?.company_name ?? "",
        gst_number: response.data.data.transporter_detail?.gst_number ?? "",
        address: response.data.data.transporter_detail?.address ?? "",
        alternate_phone:
          response.data.data.transporter_detail?.alternate_phone ?? "",
        aadhar_number:
          response.data.data.transporter_detail?.aadhar_number ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);
  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateData = () => {
    const newErrors = {};
    if (!formData.name) {
      newErrors.nameError = "Name is requried";
    }
    if (!formData.company_name) {
      newErrors.companyError = "Company name is requried";
    }
    setResponseError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateData()) {
      isLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/transporter/update-profile`,
          {
            name: formData.name,
            phone: formData.phone,
            gst_number: formData.gst_number,
            address: formData.address,
            company_name: formData.company_name,
            alternate_phone: formData.alternate_phone,
            aadhar_number: formData.aadhar_number,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        var localData = {
          name: response.data.data.name,
          type: response.data.data.type,
          email: response.data.data.email,
          phone: response.data.data.phone,
        };
        Cookies.set("bz_uinf", JSON.stringify(localData), { expires: 7 });
        config.user =
          Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setMode("show");
        fetchUserProfile();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        isLoading(false);
      }
    }
  };
  const [mode, setMode] = useState("show");
  const handleMode = (mode) => {
    setMode(mode);
  };
  const user = config.user;
  const userType = user ? user.type : "";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="row-layout dashborad-profile">
              <div className="card mb-2">
                <div className="card-body p-0">
                  <div className="user-image">
                    <img src={profile} alt="" />
                    <div className="edit-image" title="User Profile">
                      <img src={camera} alt="" />
                    </div>
                  </div>
                  <h6 className="text-center mt-1 mb-0">{formData.name}</h6>
                  <p className="text-center m-0 text-capitalize">
                    {userType && "Transpoter"}
                  </p>
                  <div className="row-hd-txt-center">
                    <img src={success} alt="icon" />
                    <h5 className="text-success">Approved</h5>
                    {/* <img src={pending} alt="icon" />
                      <h5 className="text-pending">Pending</h5> */}
                  </div>
                </div>
              </div>

              <div className="row align-items-center">
                <div className="col-6">
                  <h6 className="mb-0">
                    {mode === "show" ? "Personal" : "Edit"} Information
                  </h6>
                </div>
                <div className="col-6 text-end">
                  {mode === "show" ? (
                    <button
                      type="button"
                      className="add-edit-btn"
                      onClick={() => handleMode("edit")}
                    >
                      <i className="bi bi-pencil"></i>Edit
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="add-edit-btn"
                      onClick={() => handleMode("show")}
                    >
                      <i className="bi bi-x-lg"></i>Cancel
                    </button>
                  )}
                  <Link to="/address" type="button" className="add-edit-btn ms-2">
                    <i className="bi bi-chevron-double-right"></i>Next
                  </Link>
                </div>
              </div>

              {mode === "show" ? (
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <table className="table table-bordered detail_table">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>
                            <span>{formData.name}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Company Name:</td>
                          <td>
                            <span>{formData.company_name || "---"}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>GST Number:</td>
                          <td>
                            <span>{formData.gst_number || "---"}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Aadhar Number:</td>
                          <td>
                            <span>{formData.aadhar_number || "---"}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Company Address:</td>
                          <td>
                            <span>{formData.address || "---"}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Phone Number:</td>
                          <td>
                            <span>{formData.phone}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Email Address:</td>
                          <td>
                            <span>{formData.email || "---"}</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Alternate Phone:</td>
                          <td>
                            <span>{formData.alternate_phone || "---"}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <form className="dashboard-form mt-1" onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-lg-4">
                      <label className="label" htmlFor="name">
                        Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-person-fill"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter name"
                        />
                      </div>
                      {responseError.nameError && (
                        <small className="input-error">
                          {responseError.nameError}
                        </small>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label className="form-label" htmlFor="company_name">
                        Company Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-building-fill"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="company_name"
                          placeholder="Enter company name"
                          name="company_name"
                          value={formData.company_name}
                          onChange={handleChange}
                        />
                      </div>
                      {responseError.companyError && (
                        <small className="input-error">
                          {responseError.companyError}
                        </small>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label className="label" htmlFor="alternate_phone">
                        Alternate Phone Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-person-fill"></i>
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          id="alternate_phone"
                          name="alternate_phone"
                          value={formData.alternate_phone}
                          onChange={handleChange}
                          onWheel={(e) => e.target.blur()}
                          placeholder="Enter alternet number"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="label" htmlFor="gst">
                        Gst Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-person-vcard-fill"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="gst"
                          placeholder="Enter gst number"
                          name="gst_number"
                          value={formData.gst_number}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="aadhar">
                        Aadhar Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-person-vcard-fill"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="aadhar"
                          placeholder="Enter aadhar number"
                          name="aadhar_number"
                          value={formData.aadhar_number}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label" htmlFor="address">
                        Company Address
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="bi bi-building-fill"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="Enter company address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 text-end">
                      <button
                        type="submit"
                        disabled={loading}
                        className="submit_btn"
                      >
                        <i className="bi bi-floppy"></i>
                        {loading ? "Submitting" : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
